import styled from 'styled-components/macro';

const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
`;

export default Breadcrumbs;
